const styles = {
    linkStyles: {
        backgroundColor: 'transparent',
        borderWidth: 0, 
        color: '#7b7b7b',
        fontSize: 16,
        textDecoration: 'none', 
    }
}

export { styles as toolbarLinkStyles };


// WEBPACK FOOTER //
// ./src/js/components/ToolbarLink/styles.ts